import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO } from '../components/SEO';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen pt-24 lg:pt-28 flex items-center justify-center px-4" data-testid="not-found-page">
      <SEO 
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Return to Capital Billing Services homepage."
        noindex
      />
      <Helmet>
        <meta name="prerender-status-code" content="404" />
      </Helmet>
      <div className="text-center max-w-xl">
        <div className="w-24 h-24 rounded-full bg-teal-50 flex items-center justify-center mx-auto mb-8">
          <Search className="w-12 h-12 text-teal-500" aria-hidden="true" />
        </div>
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
        <p className="text-gray-500 text-lg mb-8 leading-relaxed">
          Sorry, the page you're looking for doesn't exist or has been moved. 
          Let us help you find what you need.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            size="lg"
            className="bg-teal-500 hover:bg-teal-600 text-white"
            onClick={() => navigate('/')}
            data-testid="404-home-btn"
          >
            <Home className="w-5 h-5 mr-2" aria-hidden="true" />
            Go to Homepage
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="border-gray-300 text-gray-700 hover:bg-gray-50"
            onClick={() => navigate(-1)}
            data-testid="404-back-btn"
          >
            <ArrowLeft className="w-5 h-5 mr-2" aria-hidden="true" />
            Go Back
          </Button>
        </div>
        <div className="mt-12 text-sm text-gray-400">
          Need help? <button onClick={() => navigate('/contact')} className="text-teal-600 hover:text-teal-700 font-medium underline" data-testid="404-contact-link">Contact us</button>
        </div>
      </div>
    </div>
  );
};
